import Vue from 'vue';

import CommonPlugin from './plugins/common-plugin';

import '../styles/generic.less';

Vue.use(CommonPlugin);

new Vue({
  el: '#app'
});
